import { Modal, Button, Input, message } from 'antd';
import { useState, useEffect, useMemo } from 'react';
import { Tag } from '../tag';
import { request } from '@/utils/request';

interface IndexProps {
  id: number;
  currentTags: string[];
  tags: Tag[];
  clearTag: () => void;
  onResult: (data: any) => void;
}

const Index: React.FC<IndexProps> = ({ id, currentTags, tags, clearTag, onResult }) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [keyText, setKeyText] = useState<string>("");
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  useEffect(() => {
    if (id) {
      setSelectedTags([...currentTags]);
      setVisible(true);
    }
  }, [id]);

  const filterTag = useMemo(() => {
    if (!keyText) return tags;
    return tags.filter(t => t.concatName.includes(keyText));
  }, [keyText, tags])

  const clear = () => {
    setVisible(false);
    setKeyText("");
    setSelectedTags([]);
    clearTag();
  }

  const handleOk = async () => {
    const { resp, error } = await request('/local/knowledge/productQA/tags', {
      method: 'POST',
      data: {
        id,
        tags: Array.from(new Set(selectedTags))
      }
    });
    if (resp?.code !== 0) return message.error(error?.message);
    message.success(resp.message);
    clear();
    onResult(resp.data);
  }

  return <Modal
    visible={visible}
    title="选择标签"
    onCancel={clear}
    width="80%"
    onOk={handleOk}
  >
    <Input placeholder="请输入关键字" onChange={(e) => setKeyText(e.target.value)} />
    {
      filterTag.map(t => <Button
        size="small"
        type={selectedTags.includes(String(t.id)) ? 'primary' : 'default'}
        style={{ marginTop: 10, marginRight: 10 }}
        key={t.id}
        onClick={() => {
          if (selectedTags.includes(String(t.id))) {
            setSelectedTags(selectedTags.filter(s => s !== String(t.id)));
          } else {
            setSelectedTags([...selectedTags, String(t.id)]);
          }
        }}
      >
        {t.concatName}
      </Button>)
    }
  </Modal>
}

export default Index;
